module.exports = __webpack_public_path__ + "img/img-receive-sec-05.png";